import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { GlobalSearchResults } from "@/features/office/global-search";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient on purpose: a strict `kind` enum would throw SearchParamError on a
// stale or hand-edited link; `kind` is narrowed by the page (`toSearchKind`).
const querySchema = z.object({
  search: z.string().optional(),
  kind: z.string().optional(),
  /**
   * Kind-lane collapse state on the "All" tab, written by
   * `useCollapsedKey("collapse", kind)`. Declared here or Zod strips it and the
   * lane toggle looks dead.
   */
  collapse: commaListSchema,
  /**
   * Row order, canonical `sort` wire string (`-relevance`). Lenient for the
   * same reason as `kind`, and narrowed by `toSearchSort`. Declared here or Zod
   * strips it and the Display menu looks dead.
   */
  sort: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/office/search")({
  component: GlobalSearchResults,
  validateSearch: querySchema,
});
